import { GroupEntity, GroupParticipant, PaginatedEntity } from '@core/entities';
import { Type } from 'class-transformer';

export class GroupMembersList extends PaginatedEntity {
  @Type(() => GroupEntity)
  members: GroupParticipant[];
}
